import {useState, useEffect} from 'react'
import Buscar from './buscar_socio.js'
import dayjs from 'dayjs'


const Armar = (props) => {
    const [socios, setSocios] = useState([])
    const [plan, setPlan] = useState(0)
    const [planes, setPlanes] = useState([])
    const [elegidos, setElegidos] = useState([])
    const [Fpago, setFpago] = useState(false)
    const [abono60, setAbono60] = useState(false)
    const [abono10, setAbono10] = useState(false)
    const [cantcuotas, setCantcuotas] = useState(0)
    
   

    const cuantos = () => {
        if (!plan) return
        const grupo = planes.find(a => plan === a.id)
        return grupo.grupo.includes('Ind') ? 1 : grupo.grupo.includes('es') ? 4 : 3
    }

    const borrar = (id) => {
        const quedan = elegidos.filter(a => id !== a.id)
        setElegidos(quedan)
    }

    useEffect (() => {
        fetch(props.back + 'admin/traer_socios_pileta', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json' 
            }
            })
            .then (response => response.json())
            .then (json => {setSocios(json)})
        fetch(props.back + 'admin/traer_importes_pileta', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json' 
            }
            })
            .then (response => response.json())
            .then (json => {setPlanes(json)})
    },[props.back, props.token, plan])

    const edad = (nacimiento) => {
        const hoy = dayjs(new Date())
        const nac = dayjs(nacimiento)
        return hoy.diff(nac, 'year')
    }
    const fconpagopordia = 'grid grid-cols-6 w-full items-center'
    const fsinpagopordia = 'grid grid-cols-5 w-full items-center'
    
    useEffect(() => {
        setElegidos([])
        const hoy = new Date()
        const mes = hoy.getMonth() + 1
        const cant = 5 - (mes - 9)
        setCantcuotas(cant)
    },[plan])

    const guardar = async () => {
        const valor = planes.find(a => a.id === plan).valor
        const recargo = planes.find(a => a.id === plan).recargo
        const contado = planes.find(a => a.id === plan).contado
        const ids = elegidos.slice(1).map(obj => obj.id).join(',')
        const cabeza = elegidos.length > 1 ? true : false 
         
        const a = {
            socio: elegidos[0].id,
            plan: plan,
            abono60: abono60,
            abono10: abono10,
            contado: Fpago,
            cantcuotas: cantcuotas,
            valorcuota: abono60 ? parseInt(((valor * 0.6 ) + 500 ) /1000) * 1000  : valor,
            valorrecargo: abono60 ? parseInt(((recargo * 0.6 ) + 500 ) /1000) * 1000 : recargo,
            valorcontado: abono10 ? (abono60 ? parseInt(((contado * 0.6 ) + 500 ) /1000) * 1000 : contado) * 0.9 : (abono60 ? parseInt(((contado * 0.6 ) + 500 ) /1000) * 1000 : contado),
            cabeza: cabeza,
            grupoIds: ids
        }
        fetch(props.back + 'admin/guardar_pagospileta', {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + props.token,
                'Content-Type': 'application/json' 
            },
            body: JSON.stringify(a)
        })
        .then (response => response.json())
        .then (json => json)
        if (elegidos.length>1)
            await guardar_incluidos()
        setPlan(0)
    }

     async function guardar_incluidos() {
        const results = []
        const quienes = elegidos.slice(1).map(obj => obj.id)
        const valor = planes.find(a => a.id === plan).valor
        const recargo = planes.find(a => a.id === plan).recargo
        const contado = planes.find(a => a.id === plan).contado
        const manda = elegidos[0].id
        const hoy = new Date()
        const mes = hoy.getMonth() + 1
        const cantcuotas = 5 - (mes - 9) 
        for (const cual of quienes) {
            try {
                const a = {
                    socio: cual,
                    plan: plan,
                    abono60: abono60,
                    contado: Fpago,
                    cantcuotas: cantcuotas,
                    valorcuota: abono60 ? parseInt(((valor * 0.6 ) + 500 ) /1000) * 1000  : valor,
                    valorrecargo: abono60 ? parseInt(((recargo * 0.6 ) + 500 ) /1000) * 1000 : recargo,
                    valorcontado: abono60 ? parseInt(((contado * 0.6 ) + 500 ) /1000) * 1000 : contado,
                    cabeza: false,
                    grupoIds: manda.toString()
                }
                const response = await  fetch(props.back + 'admin/guardar_pagospileta',{
                    body : JSON.stringify(a),
                    method: 'POST',
                    headers: {
                        'Authorization': 'Bearer ' + props.token,
                        'Content-Type': 'application/json' 
                    }
                })
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)
                const result = await response.json();
                results.push({ success: true, data: result })
            } catch (error) {
                results.push({ success: false, error: error.message, data: cual });
            }
        }
        return results
    }

    const pagar = (contado) => {

        return ! abono10 ? (abono60 ? contado * 0.6 : contado) : parseInt(((abono60 ? contado * 0.6 : contado) * 0.9 + 500) /1000) * 1000
    }

   return (<>
        <div className='flex flex-row px-2 h-3/4 overflow-y-auto overflow-x-hidden'>
            <div className='flex flex-col w-1/2 items-center mt-2'>
            <div className='flex flex-row justify-between items-center w-5/6'>
                <label className='text-lg'>Planes disponibles</label>  
                <div className='flex flex-row justify-between items-center'>
                    <input 
                        type='checkbox'
                        value={abono60}
                        checked={abono60}
                        onChange = {e => setAbono60(!abono60)}
                    />
                    <label className='ml-5'>Abono al 60%</label>
                </div>
               <div className='flex flex-row justify-between items-center'>
                    <input 
                        type='checkbox'
                        value={abono10}
                        checked={abono10}
                        onChange = {e => {setAbono10(!abono10); setFpago(true)}}
                    />
                    <label className='ml-5'>10% extra pago contado YA!!</label>
                </div>
            </div> 
                <div className='flex flex-col mt-2 w-full border-b-2 border-zinc-800 pb-2'>
                     <div className={abono60 ? fconpagopordia : fsinpagopordia}>
                        <div className='col-span-3'></div>
                        <div className='font-semibold flex justify-end px-2'>Contado</div>
                        {!abono10 && <div className='font-semibold flex justify-end px-2 '>{cantcuotas + ' cuotas'}</div>}
                        {abono60 ? 
                            <div className='font-semibold flex justify-end px-2 '>pago diario</div>
                        : '' }
                    </div>
                    {planes.map(a => {
                        return (

                           <div className={abono60 ? fconpagopordia : fsinpagopordia}>
                                <div className='flex flex-row col-span-3'>
                                    <input 
                                        type='radio'
                                        value={plan}
                                        checked={plan===a.id}
                                        onChange = {e => setPlan(a.id)}
                                    />
                                    <label className=' w-full ml-5 text-base'>{a.grupo}</label>
                                </div>
                                <label className='flex justify-end px-2'>{pagar(a.contado)}</label>
                                {!abono10 && <label className='flex justify-end px-2'>{abono60 ? parseInt(((a.valor * 0.6 ) + 500 ) /1000) * 1000  : a.valor}</label>}
                                {abono60 ? 
                                    <label className='flex justify-end px-2'>{a.pagopordia}</label>
                                : '' }
                            </div>
                        )
                    })}
                </div>
                <div className='flex flex-row justify-between mt-1 w-full items-start'>
                {plan && elegidos.length ? (<>
                        <div className='flex flex-col items-center w-3/4'>
                        <label className='text-lg'>Socios seleccionados {elegidos.length}</label>
                            <div className='flex flex-row font-semibold justify-between w-3/4'>
                                <label className='ml-10'>Apellido y nombre</label>
                                <label>Edad</label>
                            </div>
                        {elegidos.map(a=> {
                            return  (
                                <div className='flex flex-row w-3/4 items-center'>
                                    <label 
                                        className='text-red-700 text-lg w-8'
                                        onClick={e => borrar(a.id)}
                                    >X</label>
                                    <div className='flex justify-between w-full'>
                                        <label className=''>{a.apellido + ' ' + a.nombre}</label>
                                        <label>{edad(a.nacimiento)}</label>
                                    </div>
                                </div>
                            )                              
                        })}
                        </div>
                        <div className='flex flex-col w-1/6 items-center'>
                        {!abono10 ? (<>
                            <div className='flex flex-row justify-between'>
                                <input 
                                    type='radio'
                                    value={Fpago}
                                    checked={Fpago}
                                    onChange = {e => setFpago(true)}
                                />
                                <label className='ml-5'>Contado</label>
                            </div>
                            <div className='flex flex-row justify-between '>
                                <input 
                                    type='radio'
                                    value={Fpago}
                                    checked={!Fpago}
                                    onChange = {e => setFpago(false)}
                                />
                                <label className='ml-5'>Cuotas</label>
                            </div>
                        </>) : <label className='ml-5'>Pago contado</label>
                        }
                        </div>
                    </>)
                : '' }
                </div>
                    {elegidos.length>=cuantos() && 
                        <button 
                            className='text-lg bg-green-300 text-zinc-800 hover:bg-green-800 hover:text-white rounded-xl p-2 mt-5'
                            onClick={e => guardar()}
                            >Guardar
                        </button>
                    }
                
                </div>
            {plan  ?
                <div className='flex flex-col w-1/2 pl-5 h-3/4'>
                    <Buscar socios={socios} elegidos={elegidos} setElegidos={setElegidos} cobrar={false} />
                </div>
            : ''}
                
        </div>
    </>)
}

export default Armar